import ajax from "../assets/uilt/ajax";

let agentThreshold = {
  toggleDistributorMode: req => {
    return ajax.post({
      url: "/back/agent-threshold/toggle-distributor-mode",
      param: req.param,
      success: req.success
    });
  },
  listAgentThresholdsByOrg: req => {
    return ajax.get({
      url: "/back/agent-threshold/list-by-org",
      param: req.param,
      success: req.success
    });
  },
  getByOrgAndUser: req =>
    ajax.get({
      url: "/back/agent-threshold/get-by-org-and-user",
      param: req.param,
      success: req.success
    }),
  setThreshold: req =>
    ajax.post({
      url: "/back/agent-threshold/set-threshold",
      param: req.param,
      success: req.success
    }),
  resetConsumed: req =>
    ajax.post({
      url: "/back/agent-threshold/reset-consumed",
      param: req.param,
      success: req.success
    })

  // END
};

export default agentThreshold;
